import { CreditDto, CreditViewModel } from '@mkp/shared/models';
import { isCreditRefundable } from '@mkp/shared/util-product';

export const toViewModel = (credit: CreditDto): CreditViewModel => ({
  id: credit.id,
  externalSource: credit.externalSource,
  externalId: credit.externalId,
  product: credit.product,
  validFrom: new Date(credit.validFrom),
  validTo: new Date(credit.validTo),
  originalValidTo: credit.originalValidTo && new Date(credit.originalValidTo),
  createdAt: credit.createdAt,
  updatedAt: credit.updatedAt ? credit.updatedAt : null,
  createdBy: credit.createdBy,
  updatedBy: credit.updatedBy,
  _version: credit._version,
  quantity: credit.quantity,
  state: credit.state,
  canBeRefund: isCreditRefundable(credit),
  walletId: credit.walletId,
  redeemableForVacancyId: credit.redeemableForVacancyId,
  vbpMetadata: credit.vbpMetadata,
});
